import React, { useState } from 'react'
import { connect } from 'react-redux'

import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import MenuItem from '@material-ui/core/MenuItem'
import Button from '@material-ui/core/Button';

import { withStyles } from '@material-ui/core';

import { handleSaveServiceCharge } from '../../actions/rfp'
import { showSnackbar } from '../../actions/snackbar'

import t from '../../utils/lang'

const styles = theme => ({
  root: {
    display: 'flex',
    gap: '32px'
  },
  panelHeader: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 'bold',
    flexBasis: '50%',
    flexShrink: 0,
    '@media screen and (max-width: 500px)': {
      fontSize: '0.8rem',
      flexBasis: '100%',
    }
  },
  panelDetails: {
    display: 'block'
  },
  textField: {
    width: 200
  }
});

const ServiceChargePanel = props => {
  const { i18n, classes, proposalSubmitted, showSnackbar } = props;
  const [serviceCharge, setServiceCharge] = useState(props.serviceCharge ? props.serviceCharge : null);
  const [serviceChargeCurrencyId, setServiceChargeCurrencyId] = useState(props.serviceChargeCurrencyId ? props.serviceChargeCurrencyId : null);

  const handleChangeServiceCharge = e => {
    setServiceCharge(e.target.value);
  }

  const handleChangeServiceChargeCurrencyId = e => {
    console.log(e.target.value)
    setServiceChargeCurrencyId(e.target.value);
  }

  const handleSaveServiceCharge = e => {
    e.preventDefault();
    const { rfpId, onHandleSaveServiceCharge } = props;
    const formData = new FormData()

    formData.append('rfpId', rfpId);
    formData.append('serviceCharge', serviceCharge);
    formData.append('serviceChargeCurrencyId', serviceChargeCurrencyId);

    onHandleSaveServiceCharge(formData).then(res => 
      showSnackbar({ message: i18n.snackbar.changesSaved })
    )
  }

  const currencies = [
    { id: 1, name: 'PLN' },
    { id: 4, name: 'EUR' }
  ]

  return (
    <ExpansionPanel style={{ marginBottom: 16 }}>
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
        <Typography className={classes.panelHeader}>{i18n.serviceCharge}</Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className={classes.panelDetails}>
        <div className={classes.root}>
          <TextField
            className={classes.textField}
            label={i18n.serviceCharge}
            defaultValue={serviceCharge}
            onChange={handleChangeServiceCharge}
            // onBlur={handleSaveServiceCharge}
            margin="normal"
            disabled={proposalSubmitted}
          />
          <TextField
            select
            className={classes.textField}
            label={i18n.currency}
            value={serviceChargeCurrencyId}
            InputLabelProps={{ shrink: !!serviceChargeCurrencyId }}
            onChange={e => handleChangeServiceChargeCurrencyId(e)}
            margin="normal"
            disabled={proposalSubmitted}
          >
            {currencies.map(option => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
            </TextField>
        </div>
      </ExpansionPanelDetails>
      {proposalSubmitted ? '' : 
        <ExpansionPanelActions>
          <Button size="small" color="primary" onClick={handleSaveServiceCharge}>
            {i18n.save}
          </Button>
        </ExpansionPanelActions>
      }
    </ExpansionPanel>
  );
}

function mapStateToProps({ rfpData }) {
  const { id, lang, statusId, serviceCharge, serviceChargeCurrencyId } = rfpData

  return {
    rfpId: id,
    i18n: t[lang],
    serviceCharge,
    serviceChargeCurrencyId,
    proposalSubmitted: statusId === 3
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onHandleSaveServiceCharge: data => dispatch(handleSaveServiceCharge(data)),
    showSnackbar: options => dispatch(showSnackbar(options))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ServiceChargePanel))


// WEBPACK FOOTER //
// ./src/components/CommercialTerms/ServiceChargePanel.js